import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import qs from 'qs';
import api from "api/axiosConfig";
import API_BASE from "configs/hostConfig";
import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  Spinner,
  useMediaQuery,
} from '@chakra-ui/react';
import { TbAdjustmentsHorizontal } from 'react-icons/tb';
import { FaSearch } from 'react-icons/fa';
import Heading from 'ui/Heading';
import Text from 'ui/Text';
import theme from 'ui/theme/theme';
// import SeoTags from 'components/SEO/SeoTags';
import { StyledTable, StyledTd, StyledTh, StyledTr } from './Management.styles';
import SelectorIcon from 'ui/SelectorIcon';
// import axios from 'axios';
import { convertLocalDateTime } from 'utils/dynDateUtils';
import Pagination from 'components/Pagination/Pagination';
import EssayFilterPanel from './components/EssayFilterPanel';
import StatusActionMenu from './components/StatusActionMenu';
import {
  // RELAY_LEVEL_MAP,
  // GENRE_MAP,
  // ESSAY_TYPE_MAP,
  // WRITING_CATEGORY_MAP,
  GRADE_LEVEL_MAP,
} from 'utils/data/options';

const SORT_BY_COLUMN = ['updated_time'];
const DefaultFilters = Object.freeze({ statusFilters: [], levelFilters: [] });
const PAGE_SIZE = 20;

function EssayManagement() {
  const navigate = useNavigate();
  const [essays, setEssays] = useState([]);
  const [essayCount, setEssayCount] = useState(0);
  const [page, setPage] = useState(1);
  const [query, setQuery] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const [filters, setFilters] = useState(
    JSON.parse(JSON.stringify(DefaultFilters))
  );
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [asc, setAsc] = useState(true);
  const [isDesktop] = useMediaQuery(`(min-width: ${theme.breakpoints.md})`);

  const params = qs.parse(useLocation().search, {
    ignoreQueryPrefix: true,
    decoder: (c) => c,
  });

  async function searchEssays(keywords) {
    setIsSearching(true);
    setFilters({ ...filters, keywords });
  }

  async function getEssays() {
    const statusList = [];
    filters.statusFilters?.map((item) => {
      statusList.push(item);
    });

    const levelList = [];
    filters.levelFilters?.map((item) => {
      levelList.push(GRADE_LEVEL_MAP[item]);
    });

    const reqestBody = {
      keywords: filters?.keywords ?? '',
      levels: levelList,
      statuses: statusList,
      type: filters?.type ? filters.type.toLocaleLowerCase() : '',
      category: filters?.category ? filters.category.toLocaleLowerCase() : '',
      page: page - 1,
      size: PAGE_SIZE,
      sortBy: params?.sortName,
      ascending: asc,
    };
    // console.log('==========search essays request boy: ', reqestBody);

    api
      .post(`${API_BASE}/api/essay-exercise/search`, reqestBody)
      .then((res) => {
        if (res.status == 200) {
          // console.log('+++++++++, search videos response: ', res.data);
          setEssays(res.data?.data?.essays);
          setEssayCount(res.data?.data?.total);
        }
      })
      .catch((err) => console.log('failed to search essays: ', err))
      .finally(() => setIsSearching(false));
  }

  useEffect(() => {
    getEssays();
  }, [page, filters, asc]);

  function updateParams(newParams) {
    const updatedParams = { ...params, ...newParams };
    const stringifiedParams = qs.stringify(updatedParams, {
      skipNulls: true,
      format: 'RFC1738',
      encode: false,
    });
    navigate(`?${stringifiedParams}`, { replace: true });
  }

  function handleSortClick(key) {
    if (params.sortName === key) {
      setAsc((prev) => !prev);
    } else {
      setAsc(true);
    }
  }

  function handleSearch(e) {
    if (e.code === 'Enter') {
      searchEssays(e.target.value);
    }
  }

  function ResultModule() {
    return <div>Result Module</div>;
  }

  function filtersNumber() {
    let number = 0;
    if (filters?.statusFilters?.length) {
      number += 1;
    }
    if (filters?.levelFilters?.length) {
      number += 1;
    }
    if (filters?.type) {
      number += 1;
    }
    if (filters?.category) {
      number += 1;
    }
    return '(' + number + ')';
  }

  function updateEssayPublishStatus(essayId, status) {
    api
      .patch(`${API_BASE}/api/essay-exercise/status?essayId=${essayId}&status=${status}`)
      .then((res) => {
        if (res.status === 200) {
          // console.log(
          //   'successfully update essay: ' +
          //     essayId +
          //     ' publish status to: ' +
          //     status
          // );
          getEssays();
        }
      });
  }

  return (
    <Box>
      {/* <SeoTags t="Video Management | Dynivy Academy" /> */}

      <Heading variant="h2">Essay Management</Heading>

      {essayCount && essayCount > 0 ? (
        <>
          <Flex
            alignItems="center"
            mt="32px"
            mb="24px"
            justifyContent="space-between"
          >
            <InputGroup w="60%">
              <InputLeftElement ml="10px" mt="6px">
                {isSearching ? (
                  <Spinner />
                ) : (
                  <FaSearch
                    onClick={() => searchEssays(query)}
                    style={{ cursor: 'pointer' }}
                  />
                )}
              </InputLeftElement>
              <Input
                // ref={searchRef}
                id="searchEssays"
                onKeyDown={handleSearch}
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                paddingLeft="56px"
                type="text"
                placeholder="Search prompt title, short prompt, id, etc."
                maxW={{ base: 'unset', md: '354px' }}
                w="100%"
                h="48px"
                _placeholder={{ fontSize: '1rem' }}
                // borderRadius="52px"
                bg="gray.50"
              />
            </InputGroup>
            <Flex>
              <Flex
                as="button"
                p={isDesktop ? '12px 18px' : '6px 8px'}
                ml="12px"
                alignItems="center"
                background="gray.50"
                border={`1px solid ${theme.colors.gray[200]}`}
                borderRadius="4px"
                _hover={{ bg: 'gray.300' }}
                onClick={() => setFilterDrawerOpen(true)}
              >
                <Text size="medium" mr="10px" fontWeight="bold">
                  Filters {filtersNumber()}
                </Text>
                <TbAdjustmentsHorizontal size="24px" />
              </Flex>
            </Flex>
          </Flex>
          {!isDesktop && (
            <Flex mb="24px">
              <ResultModule />
            </Flex>
          )}
          {isDesktop ? (
            <StyledTable>
              <StyledTr>
                <StyledTh className="leftAlign" isGray p="20px 14px">
                  <Text size="medium" fontWeight="bold" mr="8px">
                    Title
                  </Text>
                </StyledTh>
                <StyledTh className="leftAlign" isGray p="20px 14px">
                  <Text size="medium" fontWeight="bold" mr="8px">
                    PromptId
                  </Text>
                </StyledTh>
                <StyledTh className="leftAlign" isGray p="20px 14px">
                  <Text size="medium" fontWeight="bold" mr="8px">
                    Author
                  </Text>
                </StyledTh>
                <StyledTh className="leftAlign" isGray p="20px 14px">
                  <Text size="medium" fontWeight="bold" mr="8px">
                    Type
                  </Text>
                </StyledTh>
                <StyledTh className="leftAlign" isGray p="20px 14px">
                  <Text size="medium" fontWeight="bold" mr="8px">
                    Category
                  </Text>
                </StyledTh>
                <StyledTh className="leftAlign" isGray p="20px 14px">
                  <Text size="medium" fontWeight="bold" mr="8px">
                    Level
                  </Text>
                </StyledTh>
                <StyledTh className="leftAlign" isGray p="20px 14px">
                  <Text size="medium" fontWeight="bold" mr="8px">
                    Status
                  </Text>
                </StyledTh>
                <StyledTh className="leftAlign" isGray p="20px 14px">
                  <Flex alignItems="center">
                    <Text size="medium" fontWeight="bold" mr="8px">
                      Updated Time
                    </Text>
                    <Flex
                      as="button"
                      type="button"
                      onClick={() => {
                        updateParams({ sortName: SORT_BY_COLUMN[0] });
                        handleSortClick(SORT_BY_COLUMN[0]);
                      }}
                    >
                      <SelectorIcon
                        asc={asc}
                        selected={params.sortName === SORT_BY_COLUMN[0]}
                      />
                    </Flex>
                  </Flex>
                </StyledTh>
                <StyledTh className="leftAlign" isGray p="20px 14px">
                  <Text size="medium" fontWeight="bold" mr="8px">
                    Action
                  </Text>
                </StyledTh>
              </StyledTr>
              <tbody>
                {essays &&
                  essays?.map((item, idx) => (
                    <StyledTr key={item.essayId}>
                      <StyledTd isEven={idx % 2 === 0} p="8px 14px">
                        <Text
                          size="medium"
                          color="semantics.link"
                          fontWeight="bold"
                        >
                          <Link to={`/`}>{item.title || item.essayId}</Link>
                        </Text>
                      </StyledTd>
                      <StyledTd isEven={idx % 2 === 0} p="8px 14px">
                        <Text size="medium">{item.promptId}</Text>
                      </StyledTd>
                      <StyledTd isEven={idx % 2 === 0} p="8px 14px">
                        <Text size="medium">{item.author}</Text>
                      </StyledTd>
                      <StyledTd isEven={idx % 2 === 0} p="8px 14px">
                        <Text size="medium">{item.type}</Text>
                      </StyledTd>
                      <StyledTd isEven={idx % 2 === 0} p="8px 14px">
                        <Text size="medium">{item.category}</Text>
                      </StyledTd>
                      <StyledTd isEven={idx % 2 === 0} p="8px 14px">
                        <Text size="medium">{item.level}</Text>
                      </StyledTd>
                      <StyledTd isEven={idx % 2 === 0} p="8px 14px">
                        <Text size="medium">{item.status}</Text>
                      </StyledTd>
                      <StyledTd isEven={idx % 2 === 0} p="8px 14px">
                        <Text size="medium">
                          {convertLocalDateTime(item.updatedTime)}
                        </Text>
                      </StyledTd>
                      <StyledTd
                        isEven={idx % 2 === 0}
                        className="leftAlign"
                        p="8px 14px"
                      >
                        <Flex
                          justifyContent="center"
                          cursor="pointer"
                          as="button"
                        >
                          {/* <Text>Action Here</Text> */}
                          <StatusActionMenu
                            item={item}
                            updateStatus={updateEssayPublishStatus}
                            isStory={false}
                          />
                        </Flex>
                      </StyledTd>
                    </StyledTr>
                  ))}
              </tbody>
            </StyledTable>
          ) : null}
        </>
      ) : null}
      <Flex justifyContent="center">
        <Pagination
          activePage={page}
          pageSize={PAGE_SIZE}
          totalItemCount={essayCount}
          pagesRange={5}
          onChange={setPage}
        />
      </Flex>
      <EssayFilterPanel
        isOpen={filterDrawerOpen}
        onClose={() => setFilterDrawerOpen(false)}
        currentFilters={filters}
        setFilters={setFilters}
        isPrompt={false}
      />
    </Box>
  );
}

export default EssayManagement;
